import React, { PropsWithChildren } from 'react';
import Grid from '@mui/material/Grid2';
import { ITopicItem } from '../../../../dataObjects/models/topics/TopicItem';
import { TopicItemsCardGridViewItem } from './TopicItemsCardGridViewItem';
import { IUser } from '../../../../dataObjects/models/users/User';
import { IChannel } from '../../../../dataObjects/models/channels/Channel';
import { IUserAccessPermissionsForObject, UserAccessPermissionsForObject } from '../../../../dataObjects/models/collaboration/ObjectUserPermissions';
import { ITopicItemViewModel } from '../../../../dataObjects/viewModels/topicItemViewModel';


export interface ITopicItemsCardGridViewProps extends PropsWithChildren<unknown> {
  topicItemViewModels: Array<ITopicItemViewModel>;
  currentUser: IUser;
  channel: IChannel;
  onDelete: (topicItem: ITopicItem) => void;
  onDeleteProfileImage: (topicItemViewModel: ITopicItemViewModel) => void;
}


export const TopicItemsCardGridView: React.FC<ITopicItemsCardGridViewProps> = (props: ITopicItemsCardGridViewProps) => {
  TopicItemsCardGridView.displayName = 'TopicItems Card Grid View';

  // eslint-disable-next-line no-console
  // console.info(`Render TopicItemsList`);

  const { topicItemViewModels, currentUser, channel, onDelete, onDeleteProfileImage } = props;

  const userPermissions: IUserAccessPermissionsForObject = new UserAccessPermissionsForObject(currentUser.id, channel);

  return (
    <>
      <Grid container spacing={2} >
        {
          // only display topicItems if there is a currentUser and a channel
          currentUser && channel &&
          topicItemViewModels.map(topicItemViewModel =>
            <Grid key={topicItemViewModel.topicItem.id} size={{ xs: 12, sm: 6, md: 4, lg: 2, xl: 2 }}>
              <TopicItemsCardGridViewItem topicItemViewModel={topicItemViewModel} userPermissions={userPermissions} onDelete={onDelete} onDeleteProfileImage={onDeleteProfileImage} />
            </Grid>
          )
        }
      </Grid>
    </>
  );

}